import { z } from 'zod';

type FormValues = {
  [key: string]: {
    [key: string]: any;
  };
};

type SelectedIntegration = {
  [key: string]: any;
};

function getAppsflyerAndroidId(
  selectedIntegration: SelectedIntegration,
): string {
  return selectedIntegration.androidId || '';
}

function getAppsflyerIosId(selectedIntegration: SelectedIntegration): string {
  return selectedIntegration.iosId || '';
}

const accountFormValidationSchemaTradeDesk = z.object({
  name: z.string().min(1, { message: 'This field is required' }),
  password: z.string().min(1, { message: 'Password required' }),
  username: z.string().min(1, { message: 'Please enter your username' }),
  accountId: z.string().min(1, { message: 'Required' }),
  partnerId: z.string().min(1, { message: 'Required' }),
});

const accountFormValidationSchemaGoogleAnalytics = z.object({
  name: z.string().min(1, { message: 'Required' }),
  accountId: z.string().min(1, { message: 'Required' }),
  propertyId: z.string().min(1, { message: 'Required' }),
});

const accountFormValidationAppsflyer = z
  .object({
    name: z.string().min(1, { message: 'Required' }),
    apiToken: z.string().min(1, { message: 'Required' }),
    androidId: z.string().optional(),
    iosId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const { androidId, iosId } = data;

    if (
      (!androidId || androidId.length === 0) &&
      (!iosId || iosId.length === 0)
    ) {
      ctx.addIssue({
        code: 'custom',
        path: ['androidId'],
        message: 'Required',
      });
      ctx.addIssue({
        code: 'custom',
        path: ['iosId'],
        message: 'Required',
      });
    }
  });

export const getInitValues = (
  selectedIntegration: SelectedIntegration,
  actionType: string,
  integrationName: string,
) => {
  const appsflyerAndroidIdValue =
    actionType === 'update' ? getAppsflyerAndroidId(selectedIntegration) : '';
  const appsflyerIosIdValue =
    actionType === 'update' ? getAppsflyerIosId(selectedIntegration) : '';
  const initValues: FormValues = {
    google_analytics: {
      name: selectedIntegration.name,
      accountId: selectedIntegration.accountId,
      propertyId: selectedIntegration.propertyId,
    },
    appsflyer: {
      name: actionType === 'update' ? selectedIntegration.name || '' : '',
      apiToken:
        actionType === 'update' ? selectedIntegration.apiToken || '' : '',
      androidId: appsflyerAndroidIdValue,
      iosId: appsflyerIosIdValue,
    },
  };

  return initValues[integrationName];
};
